import {AppController} from '../controller/app.controller';
import LayoutStandardTemplate from '../../template/layout-standard.html';

export const LayoutStandardComponent = {
    template: LayoutStandardTemplate,
    controller: AppController,
    controllerAs: 'appCtrl',
};
